export default __webpack_public_path__ + "static/media/ABB.10b466d1.png";